// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_TransactionRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_TransactionRow — one row for GET /subscriptions/(:num)/transactions.
 *
 * Represents a platform-revenue ledger entry. amount_cents is integer cents;
 * the frontend formats BRL display. Datetime fields are ISO-8601 UTC strings
 * (controller converts GMT-3 before fromRows()).
 *
 * attempts — ordered attempt sequence for this charge (chronological ASC).
 * Each entry: {status: string, event_type: string, created_at: string|null}.
 * Single-attempt charges yield a one-element array; charges that were overdue
 * and later confirmed carry the full pending→confirmed sequence. Empty when no
 * subscription_events exist for this charge_id (e.g. legacy rows).
 */
import type { Subscriptions_TransactionAttemptRow } from './Subscriptions_TransactionAttemptRow'
import { registerContract } from './validate'

export interface Subscriptions_TransactionRow {
id: number
subscription_id: number
kind?: string
amount_cents?: number
currency?: string
status?: string
provider?: string
provider_charge_id?: string
paid_at?: string
created_at?: string
attempts?: Subscriptions_TransactionAttemptRow[]
}

registerContract('Subscriptions_TransactionRow', {
  id:                 { type: 'number',  required: true },
  subscription_id:    { type: 'number',  required: true },
  kind:               { type: 'string',  required: false },
  amount_cents:       { type: 'number',  required: false },
  currency:           { type: 'string',  required: false },
  status:             { type: 'string',  required: false },
  provider:           { type: 'string',  required: false },
  provider_charge_id: { type: 'string',  required: false },
  paid_at:            { type: 'string',  required: false },
  created_at:         { type: 'string',  required: false },
  attempts: {
    type: 'array',
    required: false,
    items: {
      status:     { type: 'string',  required: false },
      event_type: { type: 'string',  required: false },
      created_at: { type: 'string',  required: false },
    },
  },
})
